import classNames from 'classnames'
import { ComponentProps } from 'react'
import { Typography } from '../Typography'
import { sprinkles, Sprinkles } from '../../theme/sprinkles.css'

type Props = Omit<ComponentProps<typeof Typography>, 'component'>

export const Paragraph = ({ children, lineHeight = 'md', ...props }: Props) => {
	const sprinklesProps: Sprinkles = {
		lineHeight
	}

	return (
		<Typography component={'p'} className={classNames(sprinkles(sprinklesProps))} {...props}>
			{children}
		</Typography>
	)
}
